import { faGift } from "@jewlr/pro-solid-svg-icons/faGift"
import {
  Box,
  FontAwesomeIcon,
  Image,
  MediaBox,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import Textarea from "components/landing/textarea"

const Grid = styled(Box).attrs((props) => ({
  display: "grid",
  gap: "40px 16px",
  gridTemplateColumns: "repeat(4, 1fr)",
  px: "46px",
  ...props,
}))``

const DealsGrid = ({ activeIndex, element, lazyload }) => (
  <MediaBox greaterThanOrEqual="desktop" width={{ tablet: "480px" }}>
    {element.textarea && (
      <Textarea element={element.textarea} style={element.textarea.style} />
    )}
    <Grid>
      {element.data.deals.map((deal, i) => {
        const active = activeIndex == i
        const expired = activeIndex > i

        const thumbnail = deal.images?.length > 0 && deal.images[0]
        const alt = thumbnail?.alt || deal.product_title
        const srcSet = thumbnail?.src
          ? `${thumbnail.src}?w=40 40w, ${thumbnail.src}?w=80 80w`
          : deal.product_image

        return (
          <Box
            key={`${element.anchor_name || element.id}-grid-${
              deal.code || deal.grid_title
            }`}
            textAlign="center"
            width="85px"
          >
            {active || expired ? (
              <Image
                alt={alt}
                lazyload={lazyload}
                mb={1}
                ratio="1 / 1"
                sizes="40px"
                srcSet={srcSet}
                title={alt}
                width="40px"
                {...(expired && { opacity: 0.6 })}
              />
            ) : (
              <FontAwesomeIcon
                color={element.style?.gift_icon_color || "garnet"}
                fontSize="40px"
                icon={faGift}
                mb={1}
              />
            )}
            <Typography fontSize="12px" fontWeight="500" letterSpacing="0.2px">
              {deal.grid_title}
            </Typography>
            {expired && (
              <Typography
                color="grey.500"
                fontSize="8px"
                letterSpacing="0.2px"
                lineHeight="1"
                mt="2px"
              >
                OFFER <br />
                NOW CLOSED
              </Typography>
            )}
          </Box>
        )
      })}
    </Grid>
  </MediaBox>
)

DealsGrid.propTypes = {
  activeIndex: PropTypes.number,
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default DealsGrid
